/**
 * Avatar color utilities
 * Provides colorful avatar backgrounds and text colors based on entity IDs
 */

// Define 10 avatar color palettes (background + text color pairs)
// These colors are specifically for avatars and won't be added to theme.js
const AVATAR_COLOR_PALETTES = [
  { background: "#FFB4AB", text: "#5F0C00" }, // Coral red
  { background: "#FFDDB5", text: "#5F2C00" }, // Warm orange
  { background: "#FFE999", text: "#483800" }, // Golden yellow
  { background: "#B4E5B4", text: "#0D4F0D" }, // Fresh green
  { background: "#A8E6CF", text: "#004D34" }, // Mint green
  { background: "#B4D7F1", text: "#003D5C" }, // Sky blue
  { background: "#C5B4E8", text: "#2D1B5E" }, // Lavender purple
  { background: "#F4B4D4", text: "#5E0D2F" }, // Rose pink
  { background: "#FFD4B4", text: "#5F2200" }, // Peach
  { background: "#D4D4F4", text: "#1B1B5E" } // Periwinkle blue
]

// Fixed color for "All staff" avatar
const ALL_STAFF_COLOR = { background: "#B6DBFF", text: "#4A5E73" }

/**
 * Get avatar color based on entity ID
 * Uses the last character of the hex ID to determine color
 * @param {string} id - The entity ID (hex string)
 * @returns {{ background: string, text: string }} Color palette object
 */
export const getAvatarColorFromId = (id) => {
  if (!id || typeof id !== "string") {
    return AVATAR_COLOR_PALETTES[0]
  }

  // Get the last character of the ID
  const lastChar = id.slice(-1).toLowerCase()

  // Convert hex character to index (0-15)
  const hexValue = parseInt(lastChar, 16)

  // Validate hex conversion - if NaN, default to first palette
  if (Number.isNaN(hexValue)) {
    return AVATAR_COLOR_PALETTES[0]
  }

  // Map 16 hex values (0-F) to 10 color palettes
  // Multiple hex values can map to the same color
  const colorIndex = hexValue % 10

  return AVATAR_COLOR_PALETTES[colorIndex]
}

/**
 * Get the fixed "All staff" avatar color
 * @returns {{ background: string, text: string }} Color palette object
 */
export const getAllStaffAvatarColor = () => ALL_STAFF_COLOR

/**
 * Check if assignees represent "All staff" (no users or groups specified)
 * @param {Array} users - Array of user objects
 * @param {Array} groups - Array of group objects
 * @returns {boolean} True if this represents "All staff"
 */
export const isAllStaff = (users = [], groups = []) => {
  return users.length === 0 && groups.length === 0
}
